// Short screen recordings shown beside FAQ answers. A clip appears on the
// page only once its `src` is set, so answers can reference clips that
// haven't been recorded yet.
//
// To add one: put the compressed MP4 (and a poster JPG) in
// src/assets/faq/, import them here, and set `src` and `poster`. Clips are
// phone recordings from the demo account, 480px wide, silent, about 14s.

import addItemVideo from "../../assets/faq/add-item.mp4";
import addItemPoster from "../../assets/faq/add-item.jpg";
import allocateStockVideo from "../../assets/faq/allocate-stock.mp4";
import allocateStockPoster from "../../assets/faq/allocate-stock.jpg";
import cashSaleVideo from "../../assets/faq/cash-sale.mp4";
import cashSalePoster from "../../assets/faq/cash-sale.jpg";
import createEventVideo from "../../assets/faq/create-event.mp4";
import createEventPoster from "../../assets/faq/create-event.jpg";
import discountVideo from "../../assets/faq/discount.mp4";
import discountPoster from "../../assets/faq/discount.jpg";
import eventReportVideo from "../../assets/faq/event-report.mp4";
import eventReportPoster from "../../assets/faq/event-report.jpg";
import finalizeEventVideo from "../../assets/faq/finalize-event.mp4";
import finalizeEventPoster from "../../assets/faq/finalize-event.jpg";
import packingListVideo from "../../assets/faq/packing-list.mp4";
import packingListPoster from "../../assets/faq/packing-list.jpg";
import refundVideo from "../../assets/faq/refund.mp4";
import refundPoster from "../../assets/faq/refund.jpg";
import restockPlanVideo from "../../assets/faq/restock-plan.mp4";
import restockPlanPoster from "../../assets/faq/restock-plan.jpg";
import splitPaymentVideo from "../../assets/faq/split-payment.mp4";
import splitPaymentPoster from "../../assets/faq/split-payment.jpg";

export type ClipId =
  | "cash-sale"
  | "split-payment"
  | "discount"
  | "create-event"
  | "allocate-stock"
  | "finalize-event"
  | "add-item"
  | "refund"
  | "event-report"
  | "staff-pay"
  | "restock-plan"
  | "packing-list";

export interface Clip {
  title: string;
  src?: string;
  poster?: string;
}

export const CLIPS: Record<ClipId, Clip> = {
  "cash-sale": { title: "Ringing up a cash sale", src: cashSaleVideo, poster: cashSalePoster },
  "split-payment": { title: "Splitting a payment between cash and card", src: splitPaymentVideo, poster: splitPaymentPoster },
  discount: { title: "Adding a discount to an item at checkout", src: discountVideo, poster: discountPoster },
  "create-event": { title: "Creating a two-day event", src: createEventVideo, poster: createEventPoster },
  "allocate-stock": { title: "Sending stock to an event", src: allocateStockVideo, poster: allocateStockPoster },
  "finalize-event": { title: "Finalizing an event after the show", src: finalizeEventVideo, poster: finalizeEventPoster },
  "add-item": { title: "Adding an item with a low-stock level", src: addItemVideo, poster: addItemPoster },
  refund: { title: "Refunding one item and putting it back in stock", src: refundVideo, poster: refundPoster },
  "event-report": { title: "Reading an event's financial report", src: eventReportVideo, poster: eventReportPoster },
  "staff-pay": { title: "Setting an employee's pay and commission" },
  "restock-plan": { title: "Adding Insight's recommended stock to an event", src: restockPlanVideo, poster: restockPlanPoster },
  "packing-list": { title: "Checking the weather and packing list", src: packingListVideo, poster: packingListPoster },
};

export const clipFor = (id?: ClipId) => {
  const clip = id ? CLIPS[id] : undefined;
  return clip?.src ? clip : undefined;
};
